import React from 'react';

import { CssBaseline } from '@mui/material';
import { StyledEngineProvider, ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

import LightTheme from './LightTheme';
import Theme from './MaterialTheme';

const ThemeProvider: React.FC = ({ children }) => (
    <StyledEngineProvider injectFirst>
        <MuiThemeProvider theme={Theme(LightTheme)}>
            <StyledThemeProvider theme={LightTheme}>
                <CssBaseline />
                {children}
            </StyledThemeProvider>
        </MuiThemeProvider>
    </StyledEngineProvider>
);

export default ThemeProvider;
